import { Card, Typography } from '@mui/material';

import { Consent } from '../../api/consent';
import { sanitizeHtml } from '../../helpers/sanitizeHtml';
import ConsentCheckbox from './ConsentCheckbox';
import { ConsentWrapper } from './ConsentField.styles';

type Props = {
    consentDetail: Consent;
};
const ConsentField = ({ consentDetail }: Props) => {
    switch (consentDetail.displayType) {
        case 'CHECKBOX':
            return (
                <ConsentWrapper>
                    <ConsentCheckbox consentDetail={consentDetail} />
                </ConsentWrapper>
            );
        case 'CHECKBOX_DEFAULT_CHECKED':
            return (
                <ConsentWrapper>
                    <ConsentCheckbox consentDetail={consentDetail} defaultChecked={true} />
                </ConsentWrapper>
            );
        case 'INFORMATION':
            return (
                <ConsentWrapper>
                    <Typography variant="body2">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(consentDetail.information!),
                            }}
                        />
                    </Typography>
                </ConsentWrapper>
            );

        default:
            return (
                <Card>
                    <Typography variant={'body1'}>Unknown consent type: {consentDetail.displayType}</Typography>
                    <Typography variant={'body1'}>{consentDetail.name}</Typography>
                    <Typography variant={'body1'}>{consentDetail.information}</Typography>
                    <Typography variant={'body1'}>{consentDetail.label}</Typography>
                    <Typography variant={'body1'}>{consentDetail.required}</Typography>
                </Card>
            );
    }
};

export default ConsentField;
